import { useTranslation } from "react-i18next";
import { Tag } from "@primereact/ui/tag";

type StatusSeverity =
  "secondary" | "info" | "warn" | "success" | "danger" | "contrast";

/** Status is never conveyed through color alone; the translated label is always present. */
const STATUS_SEVERITIES: Record<string, StatusSeverity> = {
  draft: "secondary",
  submitted: "info",
  in_process: "warn",
  processed: "success",
  closed: "secondary",
  cancelled: "danger",
  ready: "info",
  sent: "info",
  accepted: "success",
  rejected: "danger",
  declined: "danger",
  planned: "secondary",
  scheduled: "info",
  in_progress: "warn",
  on_hold: "warn",
  completed: "success",
  issued: "info",
  credited: "contrast",
  unpaid: "warn",
  partially_paid: "warn",
  paid: "success",
  overpaid: "contrast",
  overdue: "danger",
  low: "secondary",
  normal: "info",
  high: "danger",
  invited: "warn",
  active: "success",
  suspended: "warn",
  deactivated: "secondary",
};

export function StatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <Tag
      severity={STATUS_SEVERITIES[status] ?? "secondary"}
      className={className}
    >
      {t(`status.${status}`, { defaultValue: status })}
    </Tag>
  );
}
